module.exports = __webpack_public_path__ + "site/img/heart1.680f4e99.svg";